import PropTypes from 'prop-types';
import React from 'react';

/**
 * Inline validation message for a single form field. Renders nothing when
 * there is no error so untouched fields keep their existing markup.
 * `d-block` forces Bootstrap to show the feedback even when the invalid
 * control is not a direct sibling (react-select, date pickers).
 * @param {object} props
 * @return {object}
 */
export const FieldError = (props) =>
    props.error ? (
        <div id={props.id} className="invalid-feedback d-block">
            {props.error}
        </div>
    ) : null;

FieldError.propTypes = {
    error: PropTypes.string,
    id: PropTypes.string,
};
